var timetable = {
	weekCount: 0,
	init: function(){
		let today = new Date();
		//let today = new Date();
		let hour = today.getHours();
		if(hour >= 0 && hour < 5){
			today.setDate(today.getDate()-1);
		}

		//console.log(today, hour);
		let youbi = today.getDay() -1;
		if(youbi < 0){
			youbi = 6;
		}
		timetable.weekCount = youbi;
		timetable.tab();
		timetable.change();
	},
	clickRadikoButton: function(){
		JWAVE.Gigya.NotifyAction({action_id:"action_radiko_button"});
			gtag('event', 'Link', {'event_category': 'radiko','event_label': 'radiko_link'})
		return true;
	},
	tab: function(){
		$("#nav_weekly ul li a").off().on("click", function(){
			timetable.weekCount = $("#nav_weekly ul li a").index(this);
			timetable.change();
		});
	},
	change: function(){
		$("#nav_weekly ul li a").removeClass("active");
		$("#nav_weekly ul li").eq(timetable.weekCount).find("a").addClass("active");

		$(".tab").removeClass("active");
		$(".tab").eq(timetable.weekCount).addClass("active");
	}
}